export enum AssignmentType {
  csvField = 'csvField',
  constantAssignment = 'constantAssignment',
  currentDate = 'currentDate',
}
